import React from 'react';
import { Search } from 'lucide-react';

/**
 * Rounded search field matching reference dashboard tables/filters.
 */
export default function SearchInput({
  value,
  onChange,
  placeholder = 'Search…',
  className = '',
  id,
  'aria-label': ariaLabel = 'Search',
}) {
  return (
    <div className={`app-search ${className}`.trim()}>
      <Search className="app-search__icon" strokeWidth={1.75} aria-hidden />
      <input
        id={id}
        type="search"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="app-search__input"
        aria-label={ariaLabel}
      />
    </div>
  );
}
